import { AuthService } from "../libs/Auth";
import { ApplicationSettingService } from "../services/ApplicationSettingService";
import { TokenService } from "../services/TokenService";

export class LogoutCtrl {
  public url: string;
  public static $inject = ['$scope', '$state', 'ApplicationSettingService', 'AuthService', 'TokenService', 'localStorageService'];
  constructor(public $scope: any,
    public $state: any,
    public applicationSettingService: ApplicationSettingService,
    public authService: AuthService,
    public tokenService: TokenService,
    public locStorage: angular.local.storage.ILocalStorageService) {
    $scope.vm = this;
    this.locStorage.remove("assetDisplayColumns");
    this.locStorage.remove("auditDisplayColumns");
    this.locStorage.remove("vTagPopupDisplayRows");
    this.locStorage.remove("LOCSTORAGEAPPSETTINGS");
    localStorage.removeItem("assetDisplayColumns");
    localStorage.removeItem("vTagPopupDisplayRows");
    this.applicationSettingService.getAuthenticationServer().then((data) => {
      if (data == null || data.length === 0) {
        this.tokenService.Logout().then(() => {
          this.authService.logout().then(() => {
          });
        });
      }
      else {
        //this.authService.logout().then(() => {
        //})
        this.tokenService.Logout().then(() => {
          $state.go('loggedout');
        });
      }
    });

    //this.tokenService.Logout().then(()=>{
    //    $state.go('loggedout');
    //})
  }
}
